import { sqliteTable, text, real } from "drizzle-orm/sqlite-core";

// ============================================================================
// crm_organizations — องค์กร/บริษัทลูกค้า
// ============================================================================
export const crmOrganizations = sqliteTable("crm_organizations", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  name: text("name").notNull(),
  website: text("website"),
  industry: text("industry"),
  employeeCount: text("employee_count", {
    enum: ["1-10", "11-50", "51-200", "201-500", "500+"],
  }),
  annualRevenue: real("annual_revenue"),
  address: text("address"),
  city: text("city"),
  province: text("province"),
  postalCode: text("postal_code"),
  country: text("country").default("TH"),
  phone: text("phone"),
  email: text("email"),
  customerId: text("customer_id"), // FK → customers (accounting) — no constraint
  remarks: text("remarks"),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
});

// Type exports
export type CrmOrganization = typeof crmOrganizations.$inferSelect;
export type NewCrmOrganization = typeof crmOrganizations.$inferInsert;
